<template>
	<div class="three_download">
		<div class="tools_download">
			<div class="item" style="margin-right: 88px">
				<div class="item_t brower">
					<img src="../../../../assets/360_big.png" alt="" />
				</div>
				<a class="item_desc text_theme" href="https://browser.360.cn/ee/" target="_blank">360极速浏览器下载</a>
			</div>
			<div class="item">
				<div class="item_t brower">
					<img src="../../../../assets/chrome_big.png" alt="" />
				</div>
				<a class="item_desc text_theme" href="https://www.google.cn/chrome/" target="_blank">谷歌浏览器下载</a>
			</div>
		</div>

		<div class="tools_download" style="margin-top: 100px">
			<div class="item" style="margin-right: 88px">
				<div class="item_t">
					<img src="../../../../assets/pro_edition.png" alt="" />
				</div>
				<!-- 专业版网页版 -->
				<a class="item_desc text_theme" href="javascript: void(0);" @click="linkToPro">专业版网页版</a>
			</div>
			<div class="item">
				<div class="item_t">
					<img src="../../../../assets/pro_edition.png" alt="" />
				</div>
				<!-- <a class="item_desc text_theme" href="http://download.uflycloud.com/%E7%A7%91%E9%A3%9E%E8%A7%86%E7%9F%A5%E8%A7%89%E4%B8%93%E4%B8%9A%E7%89%882.0%E5%AE%89%E8%A3%85%E5%8C%85win32.exe">电脑客户端下载</a> -->
				<a
					class="item_desc text_theme"
					href="http://download.uflycloud.com/%E7%A7%91%E9%A3%9E%E8%A7%86%E7%9F%A5%E8%A7%89%E5%AD%A6%E4%B9%A0%E6%B2%BB%E7%96%97%E8%BD%AF%E4%BB%B6V1%E5%AE%89%E8%A3%85%E5%8C%85win32.exe"
				>
					电脑客户端下载
				</a>
			</div>
		</div>
		<!-- v-if="false" -->
		<div class="tools_download" style="margin-top: 100px">
			<div class="item" style="margin-right: 88px">
				<div class="item_t">
					<img src="../../../../assets/fun_edition.png" alt="" />
				</div>
				<a class="item_desc text_theme" href="https://training.uflyvision.com.cn/eaglefun/" target="_blank">趣味版网页版</a>
			</div>
			<div class="item">
				<div class="item_t">
					<img src="../../../../assets/fun_edition.png" alt="" />
				</div>
				<a
					class="item_desc text_theme"
					href="http://download.uflycloud.com/%E7%A7%91%E9%A3%9E%E8%A7%86%E7%9F%A5%E8%A7%89%E8%B6%A3%E5%91%B3%E7%89%882.0%E5%AE%89%E8%A3%85%E5%8C%85win32.exe"
				>
					电脑客户端下载
				</a>
				<!-- <a class="item_desc text_theme" href="http://download.uflycloud.com/%E7%A7%91%E9%A3%9E%E8%A7%86%E7%9F%A5%E8%A7%89%E5%AD%A6%E4%B9%A0%E6%B2%BB%E7%96%97%E8%BD%AF%E4%BB%B6V1-%E8%B6%A3%E5%91%B3%E7%89%88%E5%AE%89%E8%A3%85%E5%8C%85win32.exe">电脑客户端下载</a> -->
			</div>
		</div>
		<div class="tools_download" style="margin-top: 100px" v-if="false">
			<!-- 	<div class="item" style="margin-right: 88px;">
				<div class="item_t">
					<img src="../../../../assets/fun_edition.png" alt="">
				</div>
				<a class="item_desc text_theme"
					href="https://ufly-downloadcenter.oss-cn-hangzhou.aliyuncs.com/%E8%A7%86%E7%9F%A5%E8%A7%89%E5%AD%A6%E4%B9%A0%E6%B2%BB%E7%96%97%E8%BD%AF%E4%BB%B6V2.0.0.0.apk"
					target="_blank">移动端apk下载</a>
			</div> -->
			<div class="item">
				<div class="item_t">
					<img src="../../../../assets/fun_edition.png" alt="" />
				</div>
				<a
					class="item_desc text_theme"
					href="https://ufly-downloadcenter.oss-cn-hangzhou.aliyuncs.com/%E8%A7%86%E7%9F%A5%E8%A7%89%E5%AD%A6%E4%B9%A0%E6%B2%BB%E7%96%97%E8%BD%AF%E4%BB%B6V2-%E5%AE%89%E8%A3%85%E5%8C%85.exe"
				>
					电脑客户端下载
				</a>
				<!-- <a class="item_desc text_theme" href="http://download.uflycloud.com/%E7%A7%91%E9%A3%9E%E8%A7%86%E7%9F%A5%E8%A7%89%E5%AD%A6%E4%B9%A0%E6%B2%BB%E7%96%97%E8%BD%AF%E4%BB%B6V1-%E8%B6%A3%E5%91%B3%E7%89%88%E5%AE%89%E8%A3%85%E5%8C%85win32.exe">电脑客户端下载</a> -->
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	props: {
		index: {
			type: Number,
			default: 0
		}
	},

	data() {
		return {
			// open: false
		};
	},
	computed: {
		...mapState(['safeInfo'])
	},
	methods: {
		// 打开专业版网页
		linkToPro() {
			let link = '';
			this.safeInfo.kt ? (link = `http://training.uflyvision.com.cn/eaglepro/?kt=${this.safeInfo.kt}`) : (link = `http://training.uflyvision.com.cn/eaglepro/`);
			window.open(link);
		}
	}
};
</script>

<style scoped>
.three_download {
	width: 1200px;
	margin: 0 auto;
	padding: 100px 0 100px 305px;
}

.tools_download {
	height: 544px;
	padding: 100px 0 0 0;
	border-radius: 25px 30px 30px 30px;
	box-shadow: 0px 2px 2px 0px rgba(132, 132, 132, 0.65);
	background: #edecec;
	text-align: center;
}

.tools_download .item {
	display: inline-block;
	width: 300px;
	vertical-align: top;
}

.tools_download .item_t {
	height: 235px;
}

.tools_download .item_desc {
	display: block;
	margin-top: 40px;
	font-size: 18px;
	text-align: center;
	line-height: 44px;
}

.tools_download .item_desc:hover {
	text-decoration: underline;
}

.tools_download .brower {
	padding: 60px 0 0 0;
	background-image: url(../../../../assets/download_tool_bg.png);
	background-size: 100% 100%;
}

.tools_download .brower img {
	display: block;
	margin: auto auto;
}
</style>
